import React, { useContext, useState } from "react";
import { FaHome, FaUsers, FaCalendarAlt } from "react-icons/fa";
import { Context } from "../../context/Context";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ setActiveComponent }) => {
  const { setToken } = useContext(Context);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken("");
    navigate("/");
  };
  return (
    <div className="w-64 bg-blue-800 text-white h-screen flex flex-col">
      <div className="p-5 text-center text-lg font-bold border-b border-blue-700">
        Panel Administratora
      </div>

      <ul className="flex-1 p-4 space-y-4">
        <li
          onClick={() => setActiveComponent("Dashboard")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaHome />
          <span>Dashboard</span>
        </li>
        <li
          onClick={() => setActiveComponent("Kalendarz")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaHome />
          <span>Kalendarz</span>
        </li>
        <li
          onClick={() => setActiveComponent("CreateUsers")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaUsers />
          <span>Stwórz użytkownika</span>
        </li>
        <li
          onClick={() => setActiveComponent("AllUsers")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaCalendarAlt />
          <span>Lista Użytkowników</span>
        </li>
        <li
          onClick={() => setActiveComponent("AllTrenerzy")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaCalendarAlt />
          <span>Lista Trenerów</span>
        </li>

        <li
          onClick={() => setActiveComponent("AllKarnets")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaCalendarAlt />
          <span>Lista Karnetów</span>
        </li>
        <li
          onClick={() => setActiveComponent("AllPayments")}
          className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-700 cursor-pointer"
        >
          <FaCalendarAlt />
          <span>Lista Płatnosci</span>
        </li>
      </ul>

      <div className="p-4 border-t border-blue-700">
        <button
          className="w-full p-2 bg-red-500 hover:bg-red-600 rounded-lg text-sm"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
